<td>
  <material-order-position-status [id]="position.position_id"
    [status]="position.status"
    (updatePosition)="updatePositionEmitter.emit($event)">
  </material-order-position-status>
</td>
<td class="align-right">{{position.index + 1}}</td>
<td class="align-right">
  @if (position.delivery_index === 0) {
    <span>1</span>
  }
  @if (position.delivery_index > 0) {
    <strong>{{position.delivery_index + 1}}</strong>
  }
</td>
<td>
  <a uiSref="a.material.inventory.update" target="_blank" [uiParams]="{variation: position.id}">
    {{position.variation_id}}
  </a>
</td>
<td>{{position.vendor_article_id}}</td>
<td>{{position.article_name}}</td>
@for (field of fields; track field) {
  <td [ngClass]="{'align-right': field.isValueType('Number')}">
    @if (!(position.fields[field.html_name]|isNull)) {
      @switch (field.data_type) {
        @case ('Option') {
      <i class="fa" [ngClass]="{
          'fa-check': (position.fields[field.html_name] === true),
          'fa-times': (position.fields[field.html_name] === false)}"></i>
        }
        @case ('Ganzzahl') {
          {{ position.fields[field.html_name] | money:0 }}
        }
        @case ('Kommazahl') {
          {{ position.fields[field.html_name] | money }}
        }
        @default {
          {{ position.fields[field.html_name] }}
        }
      }
    }
  </td>
}
<td>{{position.date_delivery|date:'dd.MM.yyyy'}}</td>
<td class="align-right">{{ position.amount_ordered|money }}</td>

@if (('material.order.price.check'|HasPerm)) {
  @if (!!position.price) {
    <td class="align-right">
      {{position.price|money:2}}&nbsp;&euro;
    </td>
  }
  @if (!position.price) {
    <td class="align-right">
    </td>
  }
  <td>
    <a class="inline-block click" [title]="setStatusTooltip" (click)="confirmPrice()">
      <i class="fa row-icon" [ngClass]="positionPriceConfirmed" aria-hidden="true"></i>
    </a>
  </td>
}

<td colspan="5"></td>

<td>
  @if (('material.order.status'|HasPerm)) {
    <a class="click"
      title="Positionsstatus auf &quot;Bestätigt&quot; zurücksetzen"
      (click)="setStatus(1)"
      >
      <i class="fa fa-undo row-icon" aria-hidden="true"></i>
    </a>
  }
</td>

<td></td>

@if (('material.order.price.check'|HasPerm)) {
  <td class="icon">
    <a [href]="finderSupplierUri"
      target="_blank"
      class="click"
      title="Im envisia finder öffnen">
      <img src="/ui/assets/images/logo_e_icon.svg" width="20px">
    </a>
  </td>
}

<td class="icon">
  <material-label-print-button [variationId]="position.id" classInner="fa-2x"></material-label-print-button>
</td>
